import mutations from "./mutations"
import actions from "./actions"
import getters from "./getters"

export default {
  namespaced: true,
  state()  {
    return {
      filesList: null,
      status: null,
      mailStatus: null,
      respFileName: null,
    }
  },
  mutations,
  actions,
  getters
}